
import { RidangoReduxAction } from '@ridango/core';

import { tassign } from 'tassign';

import { SwishActions } from './swish.actions';


export interface SwishState {
    transaction: any;
    transactionStatus: string;
    accountId: string;
    error: any;
}

export const SWISH_INITIAL_STATE: SwishState = {
    transaction: null,
    transactionStatus: null,
    accountId: null,
    error: null,
};

export const SWISH_STATE_KEY = 'swish';

export function swishReducer( lastState: SwishState = SWISH_INITIAL_STATE, action: RidangoReduxAction ): SwishState {
    switch ( action.type ) {
        case SwishActions.SET_TRANSACTION_DATA:
            return tassign( lastState, {
                transaction: action.payload,
                error: null
            } );
        case SwishActions.CLEAR_TRANSACTION_DATA:
            return tassign( lastState, {
                transaction: null
            } );
        case SwishActions.SET_TRANSACTION_STATUS:
            return tassign( lastState, {
                transactionStatus: action.payload
            } );
        case SwishActions.SET_ACCOUNT_ID:
            return tassign( lastState, {
                accountId: action.payload
            } );
        case SwishActions.START_TRANSACTION:
            return tassign( lastState );
        case SwishActions.START_TRANSACTION_FAILED:
            return tassign( lastState, {
                error: action.payload
            });
    }
    return lastState;
}

export interface SwishPartialStoreState {
    [SWISH_STATE_KEY]: SwishState;
}
